export default __webpack_public_path__ + "static/media/compareFaces_guide.d0233c39.png";